import { createI18n } from 'vue-i18n'

/**
 * Load locale messages
 *
 * The loaded `JSON` locale messages is pre-compiled by `@intlify/vue-i18n-loader`, which is integrated into `vue-cli-plugin-i18n`.
 * See: https://github.com/intlify/vue-i18n-loader#rocket-i18n-resource-pre-compilation
 */

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key).default
    }
  })
  return messages
}

const messages = loadLocaleMessages();

function getDefaultLocale(messages) {
  // 1. 先讀 localStorage 有沒有
  const stored = localStorage.getItem('locale')
  if (stored && messages[stored]) return stored

  // 2. 沒有才照你剛剛的 browser 判斷
  const browserLang = (navigator.language || navigator.userLanguage || 'en').replace('_', '-');
  const exactKey = Object.keys(messages).find(
    k => k.toLowerCase() === browserLang.toLowerCase()
  );
  if (exactKey) return exactKey;
  if (browserLang.toLowerCase().startsWith('zh-tw') && messages['zh-TW']) return 'zh-TW';
  if (browserLang.toLowerCase().startsWith('zh-cn') && messages['zh-CN']) return 'zh-CN';
  if (browserLang.toLowerCase().startsWith('zh')) {
    if (messages['zh-TW']) return 'zh-TW';
    if (messages['zh-CN']) return 'zh-CN';
  }
  if (browserLang.toLowerCase().startsWith('en') && messages['en']) return 'en';
  return 'en';
}


export default createI18n({
  locale: getDefaultLocale(messages),
  fallbackLocale: 'en',
  messages
})